import { useLiveAPIContext } from "../../contexts/LiveAPIContext";
import Select from "react-select";
import { useEffect, useState } from "react";

const avatarOptions = [
    { value: "meeting", label: "Meeting (Standart)" },
    { value: "door2door", label: "Door-to-Door (Satış)" },
];

export default function AvatarSelector() {
    const { avatarMode, setAvatarMode } = useLiveAPIContext();
    const [selectedOption, setSelectedOption] = useState<{ value: string; label: string }>(avatarOptions[0]);

    useEffect(() => {
        const found = avatarOptions.find(o => o.value === avatarMode);
        if (found) setSelectedOption(found);
    }, [avatarMode]);

    return (
        <div className="select-group">
            <label htmlFor="avatar-selector">Avatar Modu</label>
            <Select
                id="avatar-selector"
                className="react-select"
                classNamePrefix="react-select"
                styles={{
                    control: (baseStyles) => ({
                        ...baseStyles,
                        background: "var(--Neutral-15)",
                        color: "var(--Neutral-90)",
                        minHeight: "33px",
                        maxHeight: "33px",
                        border: 0,
                    }),
                    option: (styles, { isFocused, isSelected }) => ({
                        ...styles,
                        backgroundColor: isFocused
                            ? "var(--Neutral-30)"
                            : isSelected
                                ? "var(--Neutral-20)"
                                : undefined,
                    }),
                }}
                value={selectedOption}
                options={avatarOptions}
                onChange={(e) => {
                    if (e) {
                        setSelectedOption(e);
                        setAvatarMode(e.value as "meeting" | "door2door");
                    }
                }}
            />
        </div>
    );
}
